export const breadcrumbClearBgStyle = {
  backgroundColor: 'transparent',
  backgroundImage: 'none',
  boxShadow: 'none',
} as const;
